var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40002 13.6C2.40002 13.1581 2.7582 12.8 3.20002 12.8H12.8C13.2419 12.8 13.6 13.1581 13.6 13.6C13.6 14.0418 13.2419 14.4 12.8 14.4H3.20002C2.7582 14.4 2.40002 14.0418 2.40002 13.6ZM5.03434 7.43429C5.34676 7.12187 5.85329 7.12187 6.16571 7.43429L7.20002 8.4686L7.20002 2.39998C7.20002 1.95815 7.5582 1.59998 8.00002 1.59998C8.44185 1.59998 8.80002 1.95815 8.80002 2.39998V8.46861L9.83434 7.43429C10.1468 7.12187 10.6533 7.12187 10.9657 7.43429C11.2781 7.74671 11.2781 8.25324 10.9657 8.56566L8.56571 10.9657C8.41568 11.1157 8.2122 11.2 8.00002 11.2C7.78785 11.2 7.58437 11.1157 7.43434 10.9657L5.03434 8.56566C4.72192 8.25324 4.72192 7.74671 5.03434 7.43429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c7638b2f77d3f6bc430789a218710a98.svg";
export { ForwardRef as ReactComponent };